import {
  CONFIG_REQUEST,
  CONFIG_ERROR,
  CONFIG_SUCCESS,
} from "../actions/config";

import HTTP from "@/utils/http.js";
import Vue from "vue";
import { AUTH_LOGOUT } from "../actions/auth";

const state = {
  config: {
    "registration_enabled": false,
    "external_orders_enabled": false,
    "work_orders_enabled": false,
    "discount_cards_enabled": false,
    "fuel_cards_enabled": false,
    "tickets_enabled": false,
    "requests_enabled": false,
    "card_accs_creation_enabled": false,
    "company_name": null,
    "currency": "рубли",
    "currency_short": "р",
  },
  config_get_status: "",
  config_once_loaded: false,
};

const getters = {
  getConfig: state => state.config,
  isConfigLoading: state => state.config_get_status === "loading",
  configOnceLoaded: state => state.config_once_loaded,

  isRegistrationEnabled: state => state.config.registration_enabled,

  isWorkOrdersEnabled: state => state.config.work_orders_enabled,
  isWorkExternalOrdersEnabled: state => state.config.external_orders_enabled,

  isDiscountCardsEnabled: state => state.config.discount_cards_enabled,
  isFuelCardsEnabled: state => state.config.fuel_cards_enabled,
  isTicketsEnabled: state => state.config.tickets_enabled,
  isRequestsEnabled: state => state.config.requests_enabled,
  isCardAccsCreationEnabled: state => state.config.card_accs_creation_enabled,
  isBonusesEnabled: state => state.config.bonuses_enabled,
  companyName: state => state.config.company_name ?? 'company name',

  getCurrencyName: state => state.config.currency,
  getCurrencyNameShort: state => state.config.currency_short,
};


const actions = {
  [CONFIG_REQUEST]: ({ commit, dispatch }) => {
    commit(CONFIG_REQUEST);
    return HTTP({ url: "config" })
      .then(resp => {
        /*commit(CONFIG_SUCCESS, {
            "external_orders_enabled" : true, 
            "work_orders_enabled" : true
        });*/
        commit(CONFIG_SUCCESS, resp.data);
      })
      .catch((err) => {
        commit(CONFIG_ERROR);
        if (err.config_get_status === 401) {
          dispatch(AUTH_LOGOUT);
        }
      });
  },
};

const mutations = {
  [CONFIG_REQUEST]: state => {
    state.config_get_status = "loading";
  },
  [CONFIG_SUCCESS]: (state, data) => {
    state.config_get_status = "success";
    Vue.set(state, "config", data);
    state.config_once_loaded = true;
  },
  [CONFIG_ERROR]: state => {
    state.config_get_status = "error";
    state.config_once_loaded = true;
  },

  [AUTH_LOGOUT]: state => {
    state.config = {};
    state.config_get_status = "";
    state.config_once_loaded = false;
  }
};

export default {
  state,
  getters,
  actions,
  mutations
};